// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface CarIconSignature {
  Element: SVGSVGElement;
}

export const CarIcon: TOC<CarIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path fill-rule="evenodd" clip-rule="evenodd" d="M18.618 9H5.382L2 15.764V21H4C4 22.104 4.897 23 6 23C7.103 23 8 22.104 8 21H16C16 22.104 16.897 23 18 23C19.103 23 20 22.104 20 21H22V15.764L18.618 9ZM6.618 11H17.382L19.382 15H4.618L6.618 11ZM9 19H15V17H9V19ZM4 17H7V19H4V17ZM17 17V19H20V17H17Z"/>
</svg>
</template>;